<template>
  <div style="padding: 20px; background: #fff" v-if="isShowFooterBtnPanel">
    <template v-for="(item, index) of lastBtnList">
      <el-button
        v-if="!item.disabled"
        :type="item.type"
        :key="index"
        :disabled="item.disabled"
        @click="btnHandler(item.clickName, item.params)"
        class="fixed-bottom-btn"
        >{{ item.title }}
      </el-button>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'ContractBtn',
    props: {
      contractStatus: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        btnList: [
          {
            title: '保存',
            type: 'primary',
            clickName: 'handleSave',
            params: '0',
            key: 'save',
          },
          {
            title: '提交审批',
            type: 'primary',
            clickName: 'handleSave',
            params: '-3',
            key: 'approval',
          },
          {
            title: '复制',
            type: 'primary',
            clickName: 'copyBtnHandler',
            key: 'copy',
          },
          {
            title: '删除',
            type: 'danger',
            clickName: 'deleteBtnHandler',
            key: 'delete',
          },
          {
            title: '创建采购合同',
            type: 'primary',
            clickName: 'createContractBtnHandler',
            key: 'createContract',
          },
          {
            title: '创建供应商发货指令',
            type: 'primary',
            clickName: 'goSupplierInstructLink',
            key: 'createSupplier',
          },
          {
            title: '创建提单',
            type: 'primary',
            clickName: 'createBillHandler',
            key: 'createBill',
          },
          {
            title: '关闭合同',
            type: 'danger',
            clickName: 'updateStatusHandler',
            params: '0',
            key: 'closeContract',
          },
          {
            title: '申请撤销',
            type: 'warning',
            clickName: 'updateStatusHandler',
            params: '2',
            key: 'approvalCancel',
          },
          {
            title: '确认撤销',
            type: 'warning',
            clickName: 'confirmCancelHandler',
            key: 'confirmCancel',
            params: '1',
          },
          {
            title: '驳回撤销',
            type: 'warning',
            clickName: 'confirmCancelHandler',
            key: 'rejectCancel',
            params: '0',
          },
          {
            title: '激活合同',
            type: 'primary',
            clickName: 'updateStatusHandler',
            params: 1,
            key: 'activity',
          },
        ],
        lastBtnList: [],
        isShowFooterBtnPanel: true,
      };
    },
    methods: {
      // 动态派发事件上去
      btnHandler(clickName, params) {
        this.$emit('btnHandler', clickName, params);
      },
      disabledBtnHandler(contractStatus) {
        // 区分销售还是采购
        const contractCategory = this.$route.query.contractCategory;
        console.log(contractCategory, '----->>');
        this.lastBtnList = this.btnList.map((item) => {
          if (['ZT00', 'ZT05', 'ZT06'].includes(contractStatus)) {
            // 已保存
            if (['save', 'delete', 'approval'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (['ZT02', 'ZT023', 'ZT024', 'ZT025', 'ZT021'].includes(contractStatus)) {
            // 审批中
            return {
              ...item,
              disabled: true,
            };
          } else if (contractStatus == 'ZT03') {
            // 已生效
            if (contractCategory == 'sales') {
              if (['copy', 'createBill', 'closeContract', 'approvalCancel'].includes(item.key)) {
                return item;
              } else {
                return {
                  ...item,
                  disabled: true,
                };
              }
            } else if (contractCategory == 'purchase') {
              if (
                ['copy', 'createSupplier', 'closeContract', 'approvalCancel'].includes(item.key)
              ) {
                return item;
              } else {
                return {
                  ...item,
                  disabled: true,
                };
              }
            }
          } else if (contractStatus == 'ZT022') {
            // 撤回审批中
            if (['rejectCancel', 'confirmCancel'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (contractStatus == 'ZT061') {
            // 修订中
            if (['save', 'approval'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (contractStatus == 'ZT051') {
            // 修订已驳回
            if (['save', 'approval'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (contractStatus == 'ZT07') {
            // 已关闭
            if (['activity'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else {
            if (['save', 'approval'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          }
        });
        this.isShowFooterBtnPanel = !this.lastBtnList.every((item) => item.disabled);
      },
    },
    watch: {
      contractStatus: {
        handler(val) {
          this.disabledBtnHandler(val);
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
